import React, { ReactNode } from 'react';
import WelcomeDefaultImg from '../../images/welcome.svg';
import Wrapper from '../Wrapper';
import Text from '../Text';
import Title from '../Title';

import './WelcomeCard.less';

export type WelcomeCardProps = {
  title?: ReactNode;
  text?: string;
  extraContent?: ReactNode;
  img?: string;
  imgHeight?: string;
};

const TWelcomeCard: React.FC<WelcomeCardProps> = ({
  title,
  text,
  extraContent,
  img,
  imgHeight,
}) => {
  const classNames = [`t-welcome-card`];

  return (
    <div className={classNames.join(' ')}>
      <div className="t-text-block">
        <Wrapper>
          <Text level={3} textColor="dark-30" rows={1}>
            {title}
          </Text>
        </Wrapper>
        <Wrapper mb={1}>
          <p className="t-welcome-card-text">{text}</p>
        </Wrapper>
        <div className="t-welcome-card-extracontent-wrapper">
          {extraContent}
        </div>
      </div>
      <div className={'t-image-wrapper'}>
        <img style={{ height: imgHeight }} src={img || WelcomeDefaultImg} />
      </div>
    </div>
  );
};

export default TWelcomeCard;
